export default __webpack_public_path__ + "static/Inter-ExtraBold-e4a4cb7133001f282a15f8edd004beab.ttf";